import {gql} from "@apollo/client";

const CORE_INCIDENT_PHASE_FIELDS = gql`
  fragment CoreIncidentPhaseSchemaFields on IncidentPhase {
    id
    name
    description
    ordering
    backgroundColor
    foregroundColor
    isDeleted
  }
`;

export const GET_INCIDENT_PHASES = gql`
  ${CORE_INCIDENT_PHASE_FIELDS}
  query GetIncidentPhases {
    incidentPhases(where: {ordering: {gte: 0}}, orderBy: {ordering: asc}) {
      ...CoreIncidentPhaseSchemaFields
      inUseBy {
        model
        count
      }
    }
    scenarioPhases: incidentPhases(where: {ordering: {lt: 0}}, orderBy: {ordering: asc}) {
      ...CoreIncidentPhaseSchemaFields
      inUseBy {
        model
        count
      }
    }
  }
`;

export const GET_ALL_INCIDENT_PHASES = gql`
  ${CORE_INCIDENT_PHASE_FIELDS}
  query GetIncidentPhases {
    incidentPhases(
      where: {isDeleted: {equals: false}, ordering: {gte: 0}}
      orderBy: {ordering: asc}
    ) {
      ...CoreIncidentPhaseSchemaFields
    }
  }
`;

export const CREATE_INCIDENT_PHASE = gql`
  ${CORE_INCIDENT_PHASE_FIELDS}
  mutation CreateIncidentPhase(
    $name: String!
    $description: String
    $ordering: Int
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneIncidentPhase(
      data: {
        name: $name
        description: $description
        ordering: $ordering
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      ...CoreIncidentPhaseSchemaFields
    }
  }
`;
export const UPDATE_INCIDENT_PHASE = gql`
  ${CORE_INCIDENT_PHASE_FIELDS}
  mutation UpdateIncidentPhase(
    $id: Int!
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneIncidentPhase(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      ...CoreIncidentPhaseSchemaFields
    }
  }
`;
export const SOFT_DELETE_INCIDENT_PHASE = gql`
  ${CORE_INCIDENT_PHASE_FIELDS}
  mutation SoftDeleteIncidentPhase($id: Int!) {
    deleteOneIncidentPhase(where: {id: $id}) {
      ...CoreIncidentPhaseSchemaFields
    }
  }
`;
export const DECREMENT_INCIDENT_PHASES = gql`
  mutation DecrementIncidentPhases($ordering: Int!) {
    updateManyIncidentPhase(where: {ordering: {gt: $ordering}}, data: {ordering: {decrement: 1}}) {
      count
    }
  }
`;
export const REORDER_PHASES = gql`
  mutation ReorderSchemaItems($items: [OrderItemType!], $schemaName: String!) {
    orderManyItems(items: $items, schemaName: $schemaName)
  }
`;
